import { HttpStatus } from '../errors';
import type { ErrorResponse } from '../errors';

export type { ErrorResponse } from '../errors';

export enum Errors {
  CONFLICT = HttpStatus.CONFLICT,
}

export type TimeSlotErrorResponse = ErrorResponse<Record<string, string>>;
